import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';

@Component({
  selector: 'app-adminusers',
  templateUrl: './adminusers.component.html',
  styleUrls: ['./adminusers.component.css']
})
export class AdminUsersComponent implements OnInit {
  @Input() tutorList: any;
  @Input() showbuttons: boolean;
  @Input() moduledisplay: boolean=false;
  @Input() school: boolean;

  @Output() manageuser: EventEmitter<any> = new EventEmitter();

  confirmUserDelete: boolean = false;
  constructor(private modulemanager: ModulemanagementService) { }

  ngOnInit(): void {
  }
  manageuserclicked(data: any) {
    this.manageuser.emit(data);
  }
}
